import React, { useEffect, useState } from "react";
import {
  Form,
  Row,
  Col,
  Space,
  Tooltip,
  Button,
  Drawer,
  Select,
  Radio,
  Alert,
  Modal,
  Input,
  notification,
} from "antd";
import { PlusOutlined, ExclamationCircleOutlined, InfoCircleOutlined, RightOutlined } from "@ant-design/icons";

import PatientForm from "../patient/PatientForm";
import CapacityDatePicker from "../../components/CapacityDatePicker";

import { create as CreateSurgicalIntervention } from "../../api/SurgicalIntervention";
import { update as UpdateSurgicalIntervention } from "../../api/SurgicalIntervention";

import { all as AllPatient } from "../../api/Patient";
import { all as AllDoctors } from "../../api/User";
import { all as AllSurgicalProcedure } from "../../api/SurgicalProcedure";
import { all as AllCareUnit } from "../../api/CareUnit.js";
import { all as AllStats } from "../../api/Stats";

import { formatFirstname, formatLastname } from '../../utils';

import moment from "moment";
import { siips_values } from '../../constants';
import { defineExpectedEndAt } from "../../core/surgicalIntervention";

const { confirm } = Modal;
const { Option } = Select;

const layout = {
  labelCol: {
    span: 6,
  },
  wrapperCol: {
    span: 16,
    className: "mx-3"
  },
};

const layoutWithoutLabel = {
  wrapperCol: {
    span: 24,
    className: "mx-2"
  },
};

const layoutSiips = {
  labelCol: {
    span: 14,
  },
  wrapperCol: {
    span: 6,
    className: "mx-3"
  },
};

const labelLayout = {
  style: {
    position: 'relative',
    display: 'inline-flex',
    alignItems: 'center',
    height: 32,
    color: 'rgba(0, 0, 0, 0.85)',
    fontSize: 14
  }
};

const layoutSelect = {
  showSearch: true,
  allowClear: true,
  optionFilterProp: "children",
};

const layoutAsyncSelect = {
  ...layoutSelect,
  filterOption: false,
  defaultActiveFirstOption: false,
};

const SurgicalInterventionForm = (props) => {
  const { surgicalIntervention } = props;
  const [visible, setVisible] = useState(false);
  const [visibleDrawerUser, setVisibleDrawerUser] = useState(false);
  const [expectedDuration, setExpectedDuration] = useState(7);
  const [patients, setPatients] = useState([]);
  const [doctors, setDoctors] = useState([]);
  const [surgicalProcedures, setSurgicalProcedures] = useState([]);
  const [careUnits, setCareUnits] = useState([]);
  const [age, setAge] = useState(null);
  const [form] = Form.useForm();
  const [editable, setEditable] = useState(true);
  const [selectedCareUnitId, setSelectedCareUnitId] = useState(null);
  const [selectedPatientId, setSelectedPatientId] = useState(null);
  const [patientBirthdate, setPatientBirthdate] = useState(null);
  const [patientStats, setPatientStats] = useState([]);
  const [startDate, setStartDate] = useState(moment());

  let timeOutFetchPatients = null;
  let timeOutFetchSurgicalProcedures = null;

  /**
   *
   * @param {*} search
   */
   const fetchPatients = async function (search) {
    AllPatient({
      current: 1,
      pageSize: 10,
      q: {
        search,
      },
    })
      .then((data) => {
        setPatients(data.results);
      });
  };

  /**
   *
   */
  const fetchDoctors = async function () {
    AllDoctors({
      current: 1,
      pageSize: 100,
      q: {
        role_id: 2
      },
    })
      .then((data) => {
        setDoctors(data.results);
      });
  };

  /**
   *
   * @param {*} search
   */
  const fetchSurgicalProcedures = async function (search) {
    AllSurgicalProcedure({
      current: 1,
      pageSize: 10,
      q: {
        search,
      },
    })
      .then((data) => {
        setSurgicalProcedures(data.results);
      });
  };

  /**
   *
   * @param {*} search
   */
  const fetchCareUnits = async function (search) {
    AllCareUnit({
      current: 1,
      pageSize: 100,
      q: {},
    })
      .then((data) => {
        setCareUnits(data.results);
      });
  };

  const onFinish = () => {
    form.validateFields().then(() => {
      if (surgicalIntervention) {
        updateIntervention();
      } else {
        createInterention();
      }
    })
    .catch((errors) => { });
  };

  const createInterention = async () => {
    if (periodInvalid()) {
      notification["error"]({
        message: "Impossible d'enregistrer le séjour",
        description:
          "Le patient fait déjà l'objet d'un séjour sur cette période.",
      });
      return;
    }

    confirm({
      title: 'Voulez vous enregistrer ce séjour ?',
      icon: <ExclamationCircleOutlined />,
      content: 'Attention, une fois la création du séjour confirmée, les éléments suivants ne pourront plus être modifiés: patient, unité, chirurgien, procédure.',
      async onOk() {
        let values = getSurgicalProcedureValues();
        await CreateSurgicalIntervention(values);

        props.onCreated();
        onClose();
      },
      onCancel() {},
    });
  }

  const updateIntervention = async () => {
    let values = getSurgicalProcedureValues();
    await UpdateSurgicalIntervention(surgicalIntervention.id, values)
      .then(() => {
        notification['success']({ message: 'Le séjour a bien été modifié.' });
      });

    props.onCreated();
    onClose();
  }

  const onClose = () => {
    props.onClose();
    setExpectedDuration(7);
    setAge(null);
    setSelectedCareUnitId(null);
    form.resetFields();
  };

  const getSurgicalProcedureValues = () => {
    let values = form.getFieldsValue();
    let {
      patient_id,
      user_id_doctor,
      surgical_procedure_id,
      care_unit_id,
      planned,
      start_at,
      expected_end_at,
      output_type,
      notes
    } = values;

    let newSurgicalIntervention = surgicalIntervention !== null ? { ...surgicalIntervention } : {};

    if (patient_id !== undefined) {
      newSurgicalIntervention.patient_id = patient_id;
    }
    if (user_id_doctor !== undefined) {
      newSurgicalIntervention.user_id_doctor = user_id_doctor;
    }
    if (surgical_procedure_id !== undefined) {
      newSurgicalIntervention.surgical_procedure_id = surgical_procedure_id;
    }
    if (care_unit_id !== undefined) {
      newSurgicalIntervention.care_unit_id = care_unit_id;
    }

    newSurgicalIntervention.notes = notes;
    newSurgicalIntervention.planned = planned;
    newSurgicalIntervention.output_type = output_type;
    newSurgicalIntervention.start_at = start_at
      .startOf("day")
      .toISOString(true);

    newSurgicalIntervention.expected_end_at = expected_end_at
      .startOf("day")
      .toISOString(true);

    newSurgicalIntervention.expected_siips = {
      base: values.expected_siips_base,
      technical: values.expected_siips_technical,
      relational: values.expected_siips_relational,
    };

    return newSurgicalIntervention;
  };

  /**
   *
   * @param {*} errorInfo
   */
  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  /**
   *
   * @param {*} startAt
   */
  const onChangeStartAtHandler = (startAt) => {
    if (startAt !== null) {
      let expectedEndAt = defineExpectedEndAt(startAt, expectedDuration);
      showExpectedEndDuration(startAt, expectedEndAt);
      form.setFieldsValue({
        expected_end_at: expectedEndAt,
      });
    }
  };

  /**
   *
   * @param {*} endAt
   */
  const onChangeEndAtHandler = (endAt) => {
    if (endAt !== null) {
      let startAt = form.getFieldValue('start_at');
      showExpectedEndDuration(startAt, endAt);
    }
  };

  /**
   *
   * @param {*} value
   */
  const onSearchPatient = function (value) {
    clearTimeout(timeOutFetchPatients);

    timeOutFetchPatients = setTimeout(() => {
      fetchPatients(value);
    }, 500);
  };

  /**
   *
   * @param {*} value
   */
  const onChangePatient = function (value) {
    let patient = patients.find((item) => item.id === value);
    onSelectPatient(patient);
  };

  /**
   *
   * @param {*} patient
   */
  const onSelectPatient = function (patient) {
    if (!patient) {
      setSelectedPatientId(null);
      setPatientBirthdate(null);
      setAge(null);
      return;
    }

    setSelectedPatientId(patient.id);
    setPatientBirthdate(patient.birthdate);
    showAge(patient.birthdate);
  }

  /**
   *
   * @param {*} date
   */
  const fetchPatientStats = function (date) {

    if (!selectedPatientId) {
      setPatientStats([]);
      return;
    }

    const values = form.getFieldsValue();

    let startOfMonth = (!!values.start_at) ? values.start_at : moment();
    let endOfMonth = (!!values.expected_end_at) ? values.expected_end_at : moment();

    if (date) {
      if (date < startOfMonth) {
        startOfMonth = date.clone();
      }

      if (date > endOfMonth) {
        endOfMonth = date.clone();
      }
    }

    let startDate = startOfMonth.clone().startOf('month').startOf('isoWeek');
    let endDate = endOfMonth.clone().startOf('month').startOf('isoWeek');
    endDate = endDate.clone().add(41, 'days');

    let payload = {
      "q": {
        "patient_ids": [selectedPatientId],
      }
    };
    AllStats(startDate, endDate, payload).then(data => {
      setPatientStats(data['stats']['stats']);
    });
  };

  const onPanelChangeHandler = function (current) {
    fetchPatientStats(current);
  };

  /**
   *
   * @param {*} value
   */
  const onSearchSurgicalProcedure = function (value) {
    clearTimeout(timeOutFetchSurgicalProcedures);
    if (!value) {
      setSurgicalProcedures([]);
      return;
    }

    timeOutFetchSurgicalProcedures = setTimeout(() => {
      fetchSurgicalProcedures(value);
    }, 500);
  };

  /**
   *
   * @param {*} id
   */
  const onChangeSurgicalProcedure = async (id) => {
    let startAt = form.getFieldValue('start_at');

    let surgicalProcedure = surgicalProcedures.find((elem) => elem.id === id);
    if (!surgicalProcedure) {
      setExpectedDuration(7);
      let expectedEndAt = moment(startAt).add(7, "days");

      form.setFieldsValue({
        expected_end_at: expectedEndAt,
        expected_siips_base: 0,
        expected_siips_technical: 0,
        expected_siips_relational: 0
      });
      return;
    }

    let timeExpected = surgicalProcedure.duration_of_stay;
    let endAt = moment(startAt).add(timeExpected, "days");

    form.setFieldsValue({
      expected_end_at: endAt,
      expected_siips_base: surgicalProcedure.siips.base,
      expected_siips_technical: surgicalProcedure.siips.technical,
      expected_siips_relational: surgicalProcedure.siips.relational
    });
    setExpectedDuration(timeExpected);
  };

  /**
   *
   * @param {*} patient
   */
  const addPatient = (patient) => {
    let alreadyIn = patients.findIndex((item) => item.id === patient.id);
    if (alreadyIn !== -1) {
      return;
    }

    let newPatients = [...patients];
    newPatients.pop();
    newPatients.push(patient);
    setPatients(newPatients);
  };

  /**
   *
   * @param {*} doctor
   */
  const addDoctorInList = (doctor) => {
    let alreadyIn = doctors.findIndex((item) => item.id === doctor.id);
    if (alreadyIn !== -1) {
      return;
    }

    let newDoctors = [...doctors];
    newDoctors.pop();
    newDoctors.push(doctor);
    setDoctors(newDoctors);
  };

  /**
   *
   * @param {*} surgicalProcedure
   */
  const addSurgicalProcedureInList = (surgicalProcedure) => {
    let alreadyIn = surgicalProcedures.findIndex((item) => item.id === surgicalProcedure.id);
    if (alreadyIn !== -1) {
      return;
    }

    const newSurgicalProcedures = [surgicalProcedure];
    setSurgicalProcedures(newSurgicalProcedures);
  };

  /**
   *
   * @param {*} careUnit
   */
  const addCareUnitInList = (careUnit) => {
    let alreadyIn = careUnits.findIndex((item) => item.id === careUnit.id);
    if (alreadyIn !== -1) {
      return;
    }

    let newCareUnits = [...careUnits];
    newCareUnits.pop();
    newCareUnits.push(careUnit);
    setCareUnits(newCareUnits);
  };

  /**
   *
   * @param {*} birthdate
   */
  const showAge = (birthdate) => {
    let newAge = moment().diff(birthdate, "years");
    setAge(newAge);
  };

  /**
   *
   * @param {*} startAt
   * @param {*} expectedEndAt
   */
  const showExpectedEndDuration = (startAt, expectedEndAt) => {
    let duration = expectedEndAt.diff(startAt, "days");
    setStartDate(startAt);
    setExpectedDuration(duration);
  };

  /**
   *
   * @param {*} data
   * @returns
   */
  const onCreatedPatientHandler = (data) => {
    form.setFieldsValue({ patient_id: data.id });
    onSelectPatient(data);

    patients.unshift(data);
  }

  const onClickNewPatient = () => {
    setVisibleDrawerUser(true);
  }

  /**
   *
   * @param {*} e
   */
  const onChangeCareUnit = (e) => {
    setSelectedCareUnitId(e);
  };

  const disabledDate = (current) => {
    // Can not select days before today and today
    if (!current) {
      return true;
    }

    let currentPatientStats =
      patientStats.find(item => item.date === current.format("YYYYMMDD"));
    return current && currentPatientStats && currentPatientStats.current > 0;
  };

  const periodInvalid = () => {
    if (!form || !selectedPatientId) {
      return true;
    }

    let expectedEndAt = moment(startDate).add(expectedDuration, "days");
    expectedEndAt = expectedEndAt.format("YYYYMMDD");
    let startAt = startDate.format("YYYYMMDD");

    let statsInvalid = patientStats.filter(item => (item.current > 0 && item.date >= startAt && item.date <= expectedEndAt));

    return statsInvalid.length > 0;
  };

  /**
   *
   * @param {*} current
   * @returns
   */
  let disabledExpectedEndDate = (current) => {
    let startAt = form.getFieldValue('start_at');
    return current && current < startAt;
  };

  useEffect(() => {
    setVisible(props.visible);

    if (props.visible) {
      fetchCareUnits();
      fetchDoctors();
    }

  }, [props.visible]);

  useEffect(() => {
    fetchPatientStats();
  }, [selectedPatientId, expectedDuration]);

  useEffect(() => {
    let initialStartAt = moment();
    let initialValues = {
      patient_id: null,
      user_id_doctor: null,
      surgical_procedure_id: null,
      care_unit_id: null,
      planned: true,
      start_at: initialStartAt,
      expected_end_at: defineExpectedEndAt(initialStartAt, expectedDuration),
      expected_siips_base: 0,
      expected_siips_technical: 0,
      expected_siips_relational: 0,
      real_siips_base: 0,
      real_siips_technical: 0,
      real_siips_relational: 0,
      output_type: "home",
      notes: null
    };

    if (surgicalIntervention) {
      let { patient=null, doctor=null, surgical_procedure=null, care_unit=null } = surgicalIntervention;

      if (patient !== null) {
        addPatient(patient);
        setPatientBirthdate(patient.birthdate);
        showAge(patient.birthdate);
      }
      if (surgical_procedure !== null)
        addSurgicalProcedureInList(surgical_procedure);
      if (doctor !== null)
        addDoctorInList(doctor);
      if (care_unit)
        addCareUnitInList(care_unit);

      initialValues.patient_id = surgicalIntervention?.patient_id;
      initialValues.user_id_doctor = surgicalIntervention?.user_id_doctor;
      initialValues.surgical_procedure_id = surgicalIntervention?.surgical_procedure_id;
      initialValues.care_unit_id = surgicalIntervention?.care_unit_id;
      initialValues.notes = surgicalIntervention?.notes;

      initialValues.start_at = moment(surgicalIntervention.start_at);
      initialValues.expected_end_at = moment(surgicalIntervention.expected_end_at);
      initialValues.planned = surgicalIntervention.planned;
      initialValues.output_type = surgicalIntervention.output_type;

      let expectedSiips = surgicalIntervention.expected_siips;
      initialValues.expected_siips_base = expectedSiips.base;
      initialValues.expected_siips_technical = expectedSiips.technical;
      initialValues.expected_siips_relational = expectedSiips.relational;

      let realSiips = surgicalIntervention.real_siips;
      initialValues.real_siips_base = realSiips.base;
      initialValues.real_siips_technical = realSiips.technical;
      initialValues.real_siips_relational = realSiips.relational;
    }

    if (surgicalIntervention) {
      setEditable(false);
    } else {
      setEditable(true);
    }

    form.setFieldsValue(initialValues);

    setSelectedCareUnitId(initialValues.care_unit_id);
    showExpectedEndDuration(
      initialValues.start_at,
      initialValues.expected_end_at
    );
  }, [surgicalIntervention, props.visible]);

  let patientOptions = patients.map((option, index) => (
    <Option key={index} value={option.id}>
      {[formatFirstname(option.firstname), formatLastname(option.lastname)].join(' ')}
    </Option>
  ));

  let doctorOptions = doctors.map((option, index) => (
    <Option key={index} value={option.id}>
      {[formatFirstname(option.firstname), formatLastname(option.lastname)].join(' ')}
    </Option>
  ));

  let careUnitOptions = careUnits.map((option, index) => (
    <Option key={index} value={option.id}>{option.name}</Option>
  ));

  let surgicalProcedureOptions = surgicalProcedures.map((option, index) => (
    <Option key={index} value={option.id}>{option.name}</Option>
  ));

  let chargeOptions = siips_values.map((option, index) => (
    <Option key={index} value={option}>{option}</Option>
  ));

  let datesDisabled = true;
  if (selectedCareUnitId) {
    datesDisabled = false;
  }

  let drawerTitle = "Ajout d'un nouveau séjour";
  let periodAlert = null;

  if (!surgicalIntervention && !datesDisabled && periodInvalid()) {
    periodAlert = (
      <Form.Item {...layoutWithoutLabel}>
        <Alert
          type="info"
          message=
            "Le patient fait déjà l'objet d'un séjour sur cette période!"
        />
      </Form.Item>
    );
  }

  let endAlert = null;
  let acknowledgment = "Non";

  let siipsFields = [
    <Col className="gutter-row" span={10}>
      <Form.Item>
        <span className="ant-form-text" style={{ fontWeight: "bold" }}>
          Soins quotidiens moyens estimés
        </span>
      </Form.Item>
      <Form.Item
        label="Soins de base"
        name="expected_siips_base"
        {...layoutSiips}
      >
        <Select
          style={{ width: 80 }}
          placeholder="1"
          disabled={!editable}
          {...layoutSelect}
        >
          {chargeOptions}
        </Select>
      </Form.Item>
      <Form.Item
        label="Soins techniques"
        name="expected_siips_technical"
        {...layoutSiips}
      >
        <Select
          {...layoutSelect}
          style={{ width: 80 }}
          placeholder="1"
          disabled={!editable}>
          {chargeOptions}
        </Select>
      </Form.Item>
      <Form.Item
        label="Soins relationnels"
        name="expected_siips_relational"
        {...layoutSiips}
      >
        <Select
          {...layoutSelect}
          style={{ width: 80 }}
          placeholder="1"
          disabled={!editable}
        >
          {chargeOptions}
        </Select>
      </Form.Item>
    </Col>
  ];

  if (surgicalIntervention) {
    drawerTitle = "Visualisation d'un séjour";

    let { end_at=null, acknowledgment_at=null, social_worker=null } = surgicalIntervention;

    if (acknowledgment_at && social_worker) {
      acknowledgment = [
        "Oui, le",
        moment(acknowledgment_at).format('DD/MM/YYYY'),
        "par",
        formatFirstname(social_worker.firstname),
        formatLastname(social_worker.lastname),
      ].join(" ");
    }

    if (end_at) {
      let endAt = moment(end_at).format('DD/MM/YYYY');
      endAlert = <Alert message={"Cette intervention a fait l'objet d'une sortie le " + endAt} type="info" showIcon />;

      siipsFields.push(
        <Col className="gutter-row" span={1}>
          <Form.Item />
          <Form.Item {...layoutWithoutLabel}>
            <RightOutlined style={{ color: "#bdbdbd" }} />
          </Form.Item>
          <Form.Item {...layoutWithoutLabel}>
            <RightOutlined style={{ color: "#bdbdbd" }} />
          </Form.Item>
          <Form.Item {...layoutWithoutLabel}>
            <RightOutlined style={{ color: "#bdbdbd" }} />
          </Form.Item>
        </Col>,
        <Col className="gutter-row mx-4" span={5}>
          <Form.Item>
            <span className="ant-form-text mx-4" style={{ fontWeight: "bold" }}>
              Soins réels
            </span>
          </Form.Item>
          <Form.Item
            name="real_siips_base"
            {...layoutSiips}
          >
            <Select
              {...layoutSelect}
              style={{ width: 80 }}
              placeholder="1"
              disabled={!editable}
            >
              {chargeOptions}
            </Select>
          </Form.Item>
          <Form.Item
            name="real_siips_technical"
            {...layoutSiips}
          >
            <Select
              {...layoutSelect}
              style={{ width: 80 }}
              placeholder="1"
              disabled={!editable}
            >
              {chargeOptions}
            </Select>
          </Form.Item>
          <Form.Item
            name="real_siips_relational"
            {...layoutSiips}
          >
            <Select
              {...layoutSelect}
              style={{ width: 80 }}
              placeholder="1"
              disabled={!editable}
            >
              {chargeOptions}
            </Select>
          </Form.Item>
        </Col>
      );
    }
  }

  let ageLabel = '-';
  if (patientBirthdate !== null && age !== null) {
    ageLabel = <>{moment(patientBirthdate).format("DD/MM/YYYY")} ({age} ans)</>;
  }

  let tooltipDates = {
    icon: <InfoCircleOutlined />,
    title: "Les dates désactivées correspondent aux dates où le patient fait déjà l'objet d'un séjour. " +
        "Un chevauchement de séjours n'est pas possible non plus!",
  };

  return (
    <Drawer
      title={drawerTitle}
      placement="left"
      closable={true}
      onClose={onClose}
      visible={visible}
      width={800}
      key="left"
      footer={
        <div
          style={{
            textAlign: "right",
          }}
        >
          <div>
            <Button onClick={onClose} style={{ marginRight: 8 }}>
              Annuler
            </Button>
            <Button onClick={onFinish} type="primary">
              Enregistrer
            </Button>
          </div>
        </div>
      }
    >
      <Form
        {...layout}
        form={form}
        name="surgical_intervention"
        onFinishFailed={onFinishFailed}
      >
        <Row>
          <Col span={6} style={{ textAlign: 'right' }}>
            <label
              {...labelLayout}
              htmlFor="surgical_intervention_patient_id"
              title="Patient"
            >
              <span className="ant-item-required">*</span>
              Patient
              <span style={{ margin: "0 8px 0 2px" }}>:</span>
            </label>
          </Col>
          <Col span={16}>
            <Space className="mx-3">
              <Tooltip placement="bottom" title="Ajouter un patient">
                <Button
                  type="primary"
                  icon={<PlusOutlined />}
                  style={{ marginBottom: 24 }}
                  onClick={onClickNewPatient}
                  disabled={!editable}
                />
              </Tooltip>
              <PatientForm
                onCreated={onCreatedPatientHandler}
                onClose={() => setVisibleDrawerUser(false)}
                visible={visibleDrawerUser}
                patient={null}
              />
              <Form.Item
                name="patient_id"
                rules={[{ required: true, message: 'La sélection d\'un patient est obligatoire' }]}
              >
                <Select
                  {...layoutAsyncSelect}
                  style={{ width: 450 }}
                  placeholder="Sélectionnez un patient"
                  onSearch={onSearchPatient}
                  onChange={onChangePatient}
                  disabled={!editable}
                  notFoundContent="Tapez pour rechercher un patient"
                >
                  {patientOptions}
                </Select>
              </Form.Item>
            </Space>
          </Col>
        </Row>
        <Form.Item label="Date de naissance">
          <span>{ageLabel}</span>
        </Form.Item>
        <Form.Item
          label="Unité de soin"
          name="care_unit_id"
          rules={[{ required: true, message: 'La sélection d\'une unité de soin est obligatoire' }]}
        >
          <Select
            {...layoutAsyncSelect}
            placeholder="Sélectionnez une unité"
            onChange={onChangeCareUnit}
            disabled={!editable}
            notFoundContent="Tapez pour rechercher une unité de soin"
          >
            {careUnitOptions}
          </Select>
        </Form.Item>
        <Form.Item
          label="Chirurgien"
          name="user_id_doctor"
          rules={[{ required: true, message: 'La sélection d\'un chirurgien est obligatoire' }]}
        >
          <Select
            {...layoutSelect}
            placeholder="Sélectionnez un chirurgien"
            notFoundContent="Tapez pour rechercher un chirugien"
            disabled={!editable}
            filterOption={(input, option) =>
              option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0 ||
              option.props.value.toLowerCase().indexOf(input.toLowerCase()) >= 0
            }
          >
            {doctorOptions}
          </Select>
        </Form.Item>
        <Form.Item
          label="Procédure chirurgicale"
          name="surgical_procedure_id"
          rules={[{ required: true, message: 'La sélection d\'une procédure est obligatoire' }]}
        >
          <Select
            {...layoutAsyncSelect}
            placeholder="Sélectionnez une procedure"
            onSearch={onSearchSurgicalProcedure}
            onChange={onChangeSurgicalProcedure}
            disabled={!editable}
            notFoundContent="Tapez pour rechercher une procedure"
          >
            {surgicalProcedureOptions}
          </Select>
        </Form.Item>
        <Form.Item label="Programmé ?" name="planned">
          <Radio.Group disabled={!editable} >
            <Radio value={true}>Oui</Radio>
            <Radio value={false}>Non</Radio>
          </Radio.Group>
        </Form.Item>
        {periodAlert}
        <Form.Item
          label="Date d'entrée"
          name="start_at"
          rules={[{ required: true }]}
          tooltip={tooltipDates}
        >
          <CapacityDatePicker
            format="DD/MM/YYYY"
            allowClear={false}
            onChange={onChangeStartAtHandler}
            onPanelChange={onPanelChangeHandler}
            disabled={!editable || datesDisabled}
            disabledDate={disabledDate}
            careUnitId={selectedCareUnitId}
          />
        </Form.Item>
        <Form.Item label="Durée moyenne de séjour">
          <span>{expectedDuration} jours</span>
        </Form.Item>
        <Form.Item
          label="Date de sortie estimée"
          name="expected_end_at"
          rules={[{ required: true }]}
          tooltip={tooltipDates}
        >
          <CapacityDatePicker
            format="DD/MM/YYYY"
            allowClear={false}
            onChange={onChangeEndAtHandler}
            onPanelChange={onPanelChangeHandler}
            disabled={!editable || datesDisabled}
            disabledDate={disabledDate || disabledExpectedEndDate}
            careUnitId={selectedCareUnitId}
          />
        </Form.Item>
        <Form.Item
          label="Mode de sortie"
          name="output_type"
        >
          <Radio.Group>
            <Radio value={"home"}>Domicile</Radio>
            <Radio value={"convalescence"}>Convalescence</Radio>
            <Radio value={"had"}>H.A.D.</Radio>
          </Radio.Group>
        </Form.Item>
        <Form.Item
          label="Accusé de réception"
          tooltip={{
            icon: <InfoCircleOutlined />,
            title: "Accusé de réception d'une assistante sociale"
          }}
        >
          {acknowledgment}
        </Form.Item>
        <Form.Item {...layoutWithoutLabel}>
          <Row>
            {siipsFields}
          </Row>
        </Form.Item>
        <Form.Item name="notes" label="Notes">
          <Input.TextArea rows={6} />
        </Form.Item>
      </Form>

      {endAlert}
    </Drawer>
  );
};

export default SurgicalInterventionForm;
